import { render, staticRenderFns } from "./loanInfo.vue?vue&type=template&id=fb77a3a6&scoped=true"
import script from "./loanInfo.vue?vue&type=script&lang=js"
export * from "./loanInfo.vue?vue&type=script&lang=js"
import style0 from "./loanInfo.vue?vue&type=style&index=0&id=fb77a3a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77a3a6",
  null
  
)

export default component.exports